<template>
  <div>
    <productBanner />
    <div class="content">
      <div class="ins">
        <div class="title">疫苗追溯协同服务平台</div>
        <div
          class="desc"
        >根据《中华人民共和国疫苗管理法》要求，我国实行疫苗全程电子追溯制度。国务院药品监督管理部门会同国务院卫生健康主管部门制定统一的疫苗追溯标准和规范，建立全国疫苗电子追溯协同平台，整合疫苗生产、流通和预防接种全过程追溯信息，实现疫苗可追溯。</div>
        <div
          class="desc"
        >数衍科技参与国家顶层设计，承接“国家疫苗追溯协同服务平台”建设工作，2020年3月31日平台正式上线运行。并依托协同平台建设经验及行业理解，助力合作伙伴建设多个省份的疫苗追溯监管平台。</div>
      </div>
      <div class="img-container">
        <img src="~assets/images/products/product6.png" alt />
      </div>
    </div>
  </div>
</template>

<script>
import productBanner from "components/product-banner";
export default {
  components: {
    productBanner
  }
};
</script>

<style lang="stylus" scoped>
.content
  padding 80px 9%
  display flex
  .ins
    flex 1
    display flex
    flex-direction column
    .title
      line-height 70px
      color #0160B7
      font-size 30px
    .desc
      line-height 1.5
      font-size 14px
      color #333333
    img
      width 100%
      margin-top 10px
  .service
    margin-top 8%
    font-size 18px
    color #333333
    margin-bottom 10px
  .fun
    color #666666
    font-size 14px
  .list
    display flex
    justify-content space-between
    margin-top 22px
    .item
      line-height 58px
      width 32%
      font-size 14px
      text-align center
      border 1px dashed #287BFF
      background rgba(240, 246, 255, 1)
  .img-container
    flex 1
    img
      width 95%
      margin-left 5%
@media screen and (min-width: 1300px) and (max-width: 1550px)
  .service
    margin-top 3% !important
@media screen and (max-width: 1300px)
  .ins
    justify-content space-between
    .title
      line-height 1 !important
    .service
      margin-top 0 !important
</style>



// WEBPACK FOOTER //
// src/pages/ymzs/ymzs.vue